const getAPIConfig = ({ method, authTokenSession, body }) => {
  const isFormData = body instanceof FormData

  const headers = {
    Accept: 'Application/json',
    Authorization: 'Bearer ' + authTokenSession,
  }

  if (!isFormData) {
    headers['Content-Type'] = 'application/json'
  }

  const config = {
    method,
    mode: 'cors',
    headers,
  }

  if (!body) return config

  return { ...config, body: isFormData ? body : JSON.stringify(body) }
}

export default getAPIConfig
